import React, { useState } from 'react';
import DeviceTest from './DeviceTests';

const DeviceTestsPage = () => {
  const [device, setDevice] = useState({
    buildingSite: '1 East 96th Street',
    agencyId: 'NYCDOB',
    deviceId: 'IP23270',
    deviceType: 'Traction',
  });

  const [tests, setTests] = useState({
    category1: { last: '10/6/2022', next: '10/6/2024', performedBy: '', witness: '', hours: '' },
    category5: { last: '1/27/2023', next: '1/27/2025', performedBy: '', witness: '', hours: '' },
    brakeMaintenance: { last: '2/27/2024', next: '2/27/2025', performedBy: '', witness: '', hours: '' },
  });

  const handleInputChange = (category, field, value) => {
    setTests({
      ...tests,
      [category]: {
        ...tests[category],
        [field]: value,
      },
    });
  };

  const handleUpdate = () => {
    // Handle the update logic here
    console.log('Updated tests:', tests);
  };

  return (
    <div className="p-6 min-h-screen flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-4xl border-2 border-gray-400">
        <h2 className="text-2xl font-bold mb-4">Device Tests</h2>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700">Building Site</label>
            <input
              type="text"
              value={device.buildingSite}
              readOnly
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-gray-700">Device ID</label>
            <input
              type="text"
              value={device.deviceId}
              readOnly
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-gray-700">Agency ID</label>
            <input
              type="text"
              value={device.agencyId}
              readOnly
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-gray-700">Device Type</label>
            <input
              type="text"
              value={device.deviceType}
              readOnly
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md bg-gray-100"
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <DeviceTest
            testName="Category 1 Inspection"
            testInfo={tests.category1}
            onChange={(value, field) => handleInputChange('category1', field, value)}
          />
          <DeviceTest
            testName="Category 5 Inspection"
            testInfo={tests.category5}
            onChange={(value, field) => handleInputChange('category5', field, value)}
          />
          <DeviceTest
            testName="Brake Maintenance"
            testInfo={tests.brakeMaintenance}
            onChange={(value, field) => handleInputChange('brakeMaintenance', field, value)}
          />
        </div>

        <div className="mt-4 flex justify-end space-x-2">
          <button
            onClick={handleUpdate}
            className="py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-700"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceTestsPage;
